import React, { createContext, useContext } from 'react';

const GameShellContext = createContext(null);

export function GameShellProvider({ value, children }) {
  return (
    <GameShellContext.Provider value={value}>
      {children}
    </GameShellContext.Provider>
  );
}

export function useGameShell() {
  return useContext(GameShellContext);
}
